import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-HIP",
  "use": "icon-HIP-usage",
  "viewBox": "0 0 27 25",
  "content": "<symbol viewBox=\"0 0 27 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-HIP\">\r\n<path d=\"M4.1 3.87496H6.16667M7.2 3.87496H9.26667M10.3 3.87496H12.3667M14.4333 11.5416H18.5M26 9.64418V24H1V10.5833M14.4333 15.375H23M14.4333 19.2083H23M5.13333 11.5416H11.3333V19.2083H5.13333V11.5416ZM1 1H26V6.75H1V1Z\" stroke=\"\" stroke-width=\"2\" stroke-miterlimit=\"10\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol